// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"841":"83b3ec21","2589":"d58c8f4e","7808":"90f99dae"}[chunkId] + ".css";
};